import { createReducer } from '@reduxjs/toolkit'
import { Actions_OrganizationTypes } from './Actions'
import { IStateOrganizationTypes } from './TReducer'

const initialState: IStateOrganizationTypes = {
  isLoading: false,
  data: null,
  responseInfo: null,
}

const ReducerOrganizationTypes = createReducer(initialState, (builder) => {
  builder
    .addCase(Actions_OrganizationTypes.store.showLoader, (state) => {
      state.isLoading = true
    })
    .addCase(Actions_OrganizationTypes.store.hideLoader, (state) => {
      state.isLoading = false
    })
    .addCase(Actions_OrganizationTypes.store.saveOrganizationTypes, (state, action) => {
      const payload = action.payload
      return { ...state, ...payload }
    })
})

export default ReducerOrganizationTypes
